import { Fragment, useState, useEffect } from 'react'
import { Dialog, Transition } from '@headlessui/react'
import Loader from '../../../components/atoms/loader';
import Axios from '../../../AxiosConfig';
import { useStore } from "../../../store";
export default function CreateHistory({
    employee_uuid,
    field,
    value,
    open,
    setOpen,
}) {
    const today = new Date().toISOString().slice(0, 10);
    const { layoutStore } = useStore();
    const [loading, setLoading] = useState(false);
    const [modalLoading, setModalLoading] = useState(true);
    const [error, setError] = useState(null);
    const [startDate, setStartDate] = useState(null);
    const saveHistory = async (data) => {
        setLoading(true);
        const resp = await Axios.post("/employee/history/create", data)
        if (resp.data.error) {
            setError(resp.data.error);
            setLoading(false);
        }
        else {
            setLoading(false);
            setOpen(false);
            layoutStore.showToaster("Employee history created successfully", "success");
        }

    };

    const getStartDate = async () => {
        const resp = await Axios.post("/employee/history/start-date", {
            field: field.name,
            employee_uuid: employee_uuid
        })
        const data = resp.data.data;
        if (data) {
            setStartDate(data);
        }
        setModalLoading(false);
    }
    useEffect(() => {
        setError(null);
        if (open) {
            setModalLoading(true);
            getStartDate();
        }
    }, [open]);
    return (
        <Transition.Root show={open} as={Fragment}>
            <Dialog as="div" className="relative z-10" onClose={setOpen}>
                <Transition.Child
                    as={Fragment}
                    enter="ease-out duration-300"
                    enterFrom="opacity-0"
                    enterTo="opacity-100"
                    leave="ease-in duration-200"
                    leaveFrom="opacity-100"
                    leaveTo="opacity-0"
                >
                    <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
                </Transition.Child>

                <div className="fixed inset-0 z-10 overflow-y-auto">
                    <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
                        <Transition.Child
                            as={Fragment}
                            enter="ease-out duration-300"
                            enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                            enterTo="opacity-100 translate-y-0 sm:scale-100"
                            leave="ease-in duration-200"
                            leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                            leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                        >
                            <Dialog.Panel className="relative transform overflow-hidden rounded-lg bg-white px-4 pb-4 pt-5 text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-sm sm:p-6">
                                <div>
                                    <div>
                                        <Dialog.Title as="h3" className="text-base font-semibold leading-6 text-gray-900">
                                            Add Historical Data
                                        </Dialog.Title>
                                        {error && (
                                            <div className="rounded-md bg-red-50 p-4">
                                                <div className="flex">
                                                    <div className="ml-3">
                                                        <h3 className="text-sm font-medium text-red-800">This Record Already Exists</h3>
                                                        <p className="text-sm text-red-700">A record is considered duplicate. If you have saved the same value with same Start and End date</p>
                                                    </div>
                                                </div>
                                            </div>
                                        )}
                                        <form className="mt-2"
                                            onSubmit={(e) => {
                                                e.preventDefault();
                                                // convert form to json
                                                const formData = new FormData(e.target);
                                                const data = Object.fromEntries(formData.entries());
                                                // add employee_uuid
                                                data.employee_uuid = employee_uuid;
                                                data.recordDisplayName = field?.displayName;
                                                data.recordType = field?.name;
                                                data.startDate = data.startDate;
                                                saveHistory(data);
                                            }}
                                        >
                                            {modalLoading && <Loader />}

                                            <div>
                                                <div className="flex justify-between">
                                                    <label htmlFor="startDate" className="block text-sm font-medium text-gray-700">
                                                        Start Date
                                                    </label>
                                                </div>
                                                <div className="mt-1">
                                                    <input
                                                        type="date"
                                                        name="startDate"
                                                        max={today}
                                                        value={startDate}
                                                        onChange={(e) => setStartDate(e.target.value)}
                                                        className="block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm"
                                                        required
                                                    />
                                                </div>
                                            </div>

                                            <div className='mt-2'>
                                                <div className="flex justify-between">
                                                    <label htmlFor="endDate" className="block text-sm font-medium text-gray-700">
                                                        End Date
                                                    </label>
                                                </div>
                                                <div className="mt-1">
                                                    <input
                                                        type="date"
                                                        name="endDate"
                                                        defaultValue={today}
                                                        className="block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm"
                                                        required
                                                    />
                                                </div>
                                            </div>

                                            <div className='mt-2'>
                                                <div className="flex justify-between">
                                                    <label htmlFor="recordType" className="block text-sm font-medium text-gray-700">
                                                        Record Type
                                                    </label>
                                                </div>
                                                <div className="mt-1">
                                                    <input
                                                        type="text"
                                                        name="recordType"
                                                        defaultValue={field?.displayName}
                                                        disabled={true}
                                                        className="block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm"
                                                        required
                                                    />
                                                </div>
                                            </div>

                                            <div className='mt-2'>
                                                <div className="flex justify-between">
                                                    <label htmlFor="recordValue" className="block text-sm font-medium text-gray-700">
                                                        Record Value
                                                    </label>
                                                </div>
                                                <div className="mt-1">
                                                    <textarea
                                                        name="recordValue"
                                                        defaultValue={value}
                                                        className="block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm"
                                                        required
                                                    />
                                                </div>
                                            </div>
                                            <div className="mt-5 sm:mt-6">
                                                <button
                                                    type="submit"
                                                    disabled={loading}
                                                    className="inline-flex w-full justify-center rounded-md bg-blue-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-blue-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-600"
                                                >
                                                    {loading ? 'Saving...' : 'Add Record'}
                                                </button>
                                            </div>
                                        </form>
                                    </div>
                                </div>

                            </Dialog.Panel>
                        </Transition.Child>
                    </div>
                </div>
            </Dialog>
        </Transition.Root>
    )
}
